import { Content } from './simple-input.styled';

export const SimpleInput = (props) => {

  return <Content {...props} />
};
